import { Link } from "react-router-dom";
import { MainLogo } from "modules/main/assets/main_logo";

const OnboardingHeader = () => {
  return (
    <header className="flex items-center bg-background py-4 lg:py-12">
      <Link to="/" className="flex flex-row items-center gap-4">
        <MainLogo color="#F97316" classname="w-12" />
        <span className="mt-2 font-bold russo-one-regular logo-text !text-3xl">
          Carriapp
        </span>
      </Link>
    </header>
  );
};

export default OnboardingHeader;
